// Стрелките по списъците и решетките в модалите на „Маркиране" — общите
// правила, за да се държат еднакво („Закрий", „Плати избраните", „Нов
// депозит", „Нова маса", „Прехвърли", „Личен отчет"):
//   - докато се пише в поле, клавишите са на полето;
//   - от поле с `LEAVE_FIELD_ON_ARROWS` ↑ ↓ ИЗЛИЗАТ: курсорът напуска полето
//     и със същото натискане изборът в списъка се мести — после всички
//     клавиши (← →, Enter) са на списъка; връщане в полето — с клик (в
//     търсачките — и с буква);
//   - в решетка ← → са съседната карта, ↑ ↓ — ред нагоре/надолу; на ръба стои.

const LEAVE_ON_ARROWS_ATTRIBUTE = "data-arrows-leave";

/** За полето, от което ↑ ↓ излизат към списъка до него (сума, име,
 *  търсачка). Многоредовите полета и InputNumber (там ↑ ↓ мени сумата) не го
 *  носят. */
export const LEAVE_FIELD_ON_ARROWS = { [LEAVE_ON_ARROWS_ATTRIBUTE]: "" } as const;

/**
 * Поема ли модалът клавиша: `false` — фокусът е в поле и клавишът е негов;
 * ↑ ↓ от поле с `LEAVE_FIELD_ON_ARROWS` изваждат курсора от полето (blur —
 * полето се нормализира както при клик извън него) и връщат `true`.
 */
export function takeKeyFromField(event: KeyboardEvent): boolean {
  const target = event.target instanceof HTMLElement ? event.target : null;
  if (target?.tagName !== "INPUT" && target?.tagName !== "TEXTAREA") return true;
  const isVertical = event.key === "ArrowUp" || event.key === "ArrowDown";
  if (!isVertical || !target.hasAttribute(LEAVE_ON_ARROWS_ATTRIBUTE)) return false;
  target.blur();
  return true;
}

export const isArrowKey = (key: string) =>
  key === "ArrowUp" || key === "ArrowDown" || key === "ArrowLeft" || key === "ArrowRight";

/**
 * Накъде отива стрелката в решетка с `columns` колони (1 — обикновен списък):
 * ← → съседната карта, ↑ ↓ ред нагоре/надолу (от непълния последен ред — на
 * последната карта); на ръба стои. Без избор (`index` −1) — първата карта.
 */
export function gridArrowIndex(key: string, index: number, count: number, columns: number) {
  if (index < 0) return 0;
  const last = count - 1;
  if (key === "ArrowLeft") return Math.max(0, index - 1);
  if (key === "ArrowRight") return Math.min(last, index + 1);
  if (key === "ArrowUp") return index - columns >= 0 ? index - columns : index;
  // ArrowDown
  return Math.floor(index / columns) < Math.floor(last / columns)
    ? Math.min(last, index + columns)
    : index;
}

/** Маркираният ред/карта (`selector` в `list`) — във видимата част на списъка. */
export function scrollMarkedIntoView(list: HTMLElement | null, selector: string) {
  list?.querySelector(selector)?.scrollIntoView?.({ block: "nearest" });
}
